<template>
  <div class="m-b-15 s_flex_ali">
    <div class="p-r-15 width-140">
      <a-button :type="active == 1 ? 'primary':''" block v-has:grantList='()=>{active = 1}'>发放明细</a-button>
    </div>
    <div class="p-r-15 width-140">
      <a-button :type="active == 2 ? 'primary':''" block v-has:usedList='()=>{active = 2}'>使用明细</a-button>
    </div>
  </div>
  <grantList v-if='active == 1' ></grantList>
  <usedList v-else></usedList>
</template>
<script>
import { onMounted,reactive, toRefs } from "vue";
import usedList from './usedList';
import grantList from './grantList';
export default {
  name:'detailed',
  components: {usedList,grantList },
  setup(props) {
    const state = reactive({
      active:1
    });
    onMounted(() => {
      
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>